// extracted by mini-css-extract-plugin
module.exports = {"dndkitDraggable":"DnDKitDraggable_dndkitDraggable__2YPZ7"};